import * as tooltipData from './tables/tooltip.data.json';
import { IReferenceTable } from "./interfaces/ITable";
import { TooltipDataType } from "./models/TooltipData";

const TooltipReferenceTable: IReferenceTable<TooltipDataType> = tooltipData as IReferenceTable<TooltipDataType>;

export default TooltipReferenceTable;
